import buttonBase from './_buttonBase';
export default {
  extends: buttonBase,
  methods: {
    performAction: function performAction(event) {
      if (this.$_checkForprivacyOptOut(this.button) == true) {
        return;
      }

      var jumpToElementId = this.button ? this.button.jumpToElementId : '';

      if (jumpToElementId) {
        event.preventDefault();
        var element = document.getElementById(jumpToElementId);
        element.scrollIntoView({
          behavior: 'smooth'
        });
        element.focus();
      }

      this.$_raiseAnalyticsEvent('JumpTo');
      return true;
    }
  }
};